"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
function setAmount(betValue) {
    return {
        type: types_1.SET_AMOUNT_VALUE,
        payload: betValue
    };
}
exports.setAmount = setAmount;
function resetAmount() {
    return {
        type: types_1.RESET_AMOUNT_VALUE
    };
}
exports.resetAmount = resetAmount;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/amount/actions.ts
// module id = 186
// module chunks = 5